<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'maksut.toimittajat.poista-dialog.poista' | translate | async }}
  </lemon-dialog-header>

  <div style="margin: 2em">
    @if (toimittajaOnKaytossaObservable | async) {
      {{ 'maksut.toimittajat.poista-dialog.poista-teksti-laskuissa-oleva' | translate | async }}
    } @else {
      {{ 'maksut.toimittajat.poista-dialog.poista-teksti' | translate | async }}
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <button class="primarybutton" mat-button mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <button class="secondarybutton" mat-button (click)="poista()">{{ 'yleiset.poista' | translate | async }}</button>
</mat-dialog-actions>
